import {Component, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {FormsModule} from '@angular/forms';

import '@datev/dacks/content';
import { FooterSpacing } from "../footer/footer-spacing";


@Component({
    selector: 'myupdates-product-change',
    templateUrl: './product-change.component.html',
    styleUrls: ['./product-change.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [FormsModule, RouterOutlet, FooterSpacing]
})
export class ProductChangeComponent {

  constructor() {
  }

}
